


























import { Component, Vue } from 'vue-property-decorator';
import { getIdFromUrl, Youtube } from 'vue-youtube';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CloseIcon from '@/components/icons/Close.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import flagKeys from '@/constants/flagKeys';
import { ETutorial } from '@/models/tutorial';

@Component({
  components: {
    FilledButton,
    Youtube,
    CloseIcon
  }
})
export default class WhatIsNewModal extends Vue {
  $refs!: {
    youtube: HTMLFormElement;
  };
  link: string = 'https://youtu.be/CRUEgOv6iZ8';

  service = new BusinessService();

  get videoId() {
    return getIdFromUrl(this.link);
  }

  get tPrefix() {
    return 'common.components.whatIsNewModal';
  }

  get youtubePlayer() {
    if (!this.$refs.youtube) return {};
    return this.$refs.youtube.player;
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  get showFeedbackModal() {
    return (
      this.getFlags.includes(flagKeys.feedbackPlatform) && this.currentProvider
    );
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  onClose() {
    eventBus.$emit('closeModal');
    if (this.business.showPlatformFeedback && this.showFeedbackModal) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: 'feedbackModal',
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        })
      );
    } else if (!this.business.seenWhatsNew)
      setTimeout(() => {
        eventBus.$emit('openNotificationArrow', {
          text: this.$t(`${this.tPrefix}.notification`),
          element: document.querySelector(
            this.$mobileCheck() ? '.action-sheet-menu__button' : '.topbar-auth'
          ),
          arrowDirection: this.$mobileCheck() && 'center'
        });
        eventBus.$emit('setNotificationMenu', ['what-is-new']);
      }, 250);
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  async created() {
    if (!this.business.seenWhatsNew && !this.isImpersonated)
      await this.service.updateBusinessFlagTutorial({
        state: true,
        flag: ETutorial.SEEN_WHATS_NEW
      });
  }

  destroyed() {
    if (!this.business.seenWhatsNew)
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.business,
        seenWhatsNew: true
      });
  }

  onLink() {
    window.open('https://support.twism.com', '_blank');
  }
}
